import { render, staticRenderFns } from "./expandable-key-figure-card.vue?vue&type=template&id=3a48f314"
import script from "./expandable-key-figure-card.vue?vue&type=script&lang=js"
export * from "./expandable-key-figure-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports